var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFaq = function SvgFaq(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 20,
    "data-width-72": 59,
    viewBox: "0 0 19.6 19.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.75 19.5a9.75 9.75 0 1 1 9.75-9.75 9.76 9.76 0 0 1-9.75 9.75m0-18A8.25 8.25 0 1 0 18 9.75 8.26 8.26 0 0 0 9.75 1.5m0 11.59a.74.74 0 0 1-.75-.75v-.44a2.33 2.33 0 0 1 1.52-2.15 2.08 2.08 0 1 0-2.77-2.62.75.75 0 1 1-1.41-.49 3.58 3.58 0 1 1 4.69 4.5.83.83 0 0 0-.56.76v.44a.75.75 0 0 1-.72.75m.92 1.99a.91.91 0 1 1-1.82 0 .91.91 0 0 1 1.82 0",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFaq);
export default ForwardRef;